export default class UnexpectedAssistantError extends Error {
  override name = "UnexpectedAssistantError";
}
